export enum UserAccessStatusEnum {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export const getUserAccessStatusLabel = (status: UserAccessStatusEnum): string => {
  switch (status) {
    case UserAccessStatusEnum.PENDING:
      return "Pendiente";
    case UserAccessStatusEnum.ACTIVE:
      return "Activo";
    case UserAccessStatusEnum.INACTIVE:
      return "Inactivo";
    default:
      return status;
  }
};

export const getUserAccessStatusOptions = (): { value: UserAccessStatusEnum; label: string }[] => {
  return Object.values(UserAccessStatusEnum).map((value) => ({
    value,
    label: getUserAccessStatusLabel(value),
  }));
};
